var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1024,
    viewBox: "-226.035 -226.037 1024 1024",
    width: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m722.221 715.895v-452.516l-159.981 159.984-66.266 66.269z",
    fill: "#00577b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m495.974 15.5 88.471 88.483 137.776 137.783v-452.515z",
    fill: "#01b0f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m-210.747-217.073 226.256 226.242 226.245-226.242z",
    fill: "#4fc9f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m252.57 246.24 226.267-226.26h-452.51z",
    fill: "#01b0f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m252.573-215.22-226.257 226.244h452.525zm-226.261 226.246 226.25-226.248z",
    fill: "#27bcf3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m263.373 257.049 226.272 226.256 66.265-66.273 159.977-159.983zm226.272 226.256 66.268-66.271z",
    fill: "#0079aa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m263.377 248.092h452.502l-149.556-149.57-76.674-76.685z",
    fill: "#0096d3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m715.887 248.092-149.564-149.57 149.556 149.57z",
    fill: "#0096d3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m-150.29-143.953v452.521l226.243-226.264z",
    fill: "#79201b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m75.953 556.447-66.268-66.268-159.975-159.994v452.495z",
    fill: "#f0453f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m330.171 789.012h452.509l-226.257-226.233z",
    fill: "#f47f7d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m93.099 551.974h452.516l-226.253-226.267z",
    fill: "#f0453f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m319.356 787.157 226.253-226.231h-452.518z",
    fill: "#f2625d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m-143.962 314.903h452.511l-226.259-226.266z",
    fill: "#a42d26"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m-143.962 323.854 226.246 226.264 226.265-226.264zm226.211 226.247-226.252-226.249z",
    fill: "#cc382f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m796.656 790.322-65.483-65.476v-946.405a4.478 4.478 0 0 0 -7.643-3.166l-233.885 233.892-233.911-233.889h-.067c-.816-.8-1.904-1.305-3.096-1.305h-473.867a4.42 4.42 0 0 0 -3.428 1.305 4.447 4.447 0 0 0 -1.311 3.166c0 1.147.436 2.292 1.311 3.166l65.48 65.48v946.395a4.483 4.483 0 0 0 4.477 4.478 4.467 4.467 0 0 0 3.166-1.311l233.885-233.873 233.906 233.873h.067c.819.804 1.912 1.311 3.104 1.311h474.125a4.48 4.48 0 0 0 3.17-7.641zm-466.485-1.31 226.252-226.232 226.259 226.23zm-254.218-232.565-226.243 226.233v-452.495l159.975 159.994zm420.021-540.947 226.247-226.249v452.515l-137.774-137.785zm219.905 232.592h-452.506l226.272-226.259.004.004 76.676 76.686 149.562 149.573h-.008zm-463.309-1.852-226.243-226.26h452.51zm-170.28-157.603 226.259 226.266h-452.511zm181.083 168.412h452.514l-159.977 159.983-66.268 66.271zm55.989 68.658 226.253 226.267h-452.516zm-10.813-1.853-226.265 226.264-226.247-226.265zm413.672 392.041-226.247-226.263 66.269-66.271 159.977-159.981zm-695.905-704.871 226.251-226.25.006.006 226.268 226.244zm-176.606-154.977 226.245 226.257-226.245 226.264zm695.899 704.879-226.253 226.231-226.265-226.229zm-756.356-777.999h452.501l-226.245 226.242z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsis);
export default __webpack_public_path__ + "static/media/nsis.73c0a94a89243996a266e070d8315941.svg";
export { ForwardRef as ReactComponent };